// Action Creators
// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
/** Opens the "connect to an existing plan" dialog when the feature is enabled for a Unified source plan. */ export const openLinkToExistingPlanModal = (isLinkToExistingPlanEnabled, sourceTaskId, sourcePlan, modalActionCreator, onDismiss)=>{
    if (!isLinkToExistingPlanEnabled || sourcePlan?.getPlanType() !== PlanType.Unified) {
        return;
    }
    const modalData = {
        modalType: ModalType.LinkToExistingPlan,
        sourceTaskId,
        onDismiss
    };
    modalActionCreator.openModal(modalData);
};
